<template>
    <div class="price-plan-summary">
      <div class='row'>
        <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
          <dean-section-title content='true'>
            <span slot='title'>
                <span class='avenir-heavy'>Prijsplannen</span>
            </span>
            <dean-section-title-item
                :icon='duplicateIcon'
                :content="true"
                @click.native="sectionRoute('standingData.pricePlans.duplicate')"
            >
              dupliceren
            </dean-section-title-item>
            <dean-section-title-item
                :icon='plusIcon'
                :content="true"
                @click.native="sectionRoute('standingData.pricePlans.add')"
            >
              toevoegen
            </dean-section-title-item>
          </dean-section-title>
          <dean-table
              :data='pricePlans'
              :columns="columns"
              :hover="true"
              @column-click='columnClick'
              @cell-click="cellClick">
          </dean-table>
          <dean-pagination
              :current-page='metaData.pageNumber'
              :total-items='metaData.totalResults'
              :items-per-page='metaData.itemsPerPage'
              :select-items-per-page='selectItemsPerPage'
              :visible-pages='metaData.visiblePages'
              @page-changed='paginationChanged'
              @items-per-page='itemsPerPageChanged'
          >
          </dean-pagination>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
  import { Vue, Component } from 'vue-property-decorator';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';

  import {
    // ICONS
    plusIcon,
    duplicateIcon,
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
  } from '@deanone/dean-components';

  @Component({
    components: {
      plusIcon,
      deanSectionTitle,
      deanSectionTitleItem,
      deanTable,
      deanPagination,
    },
  })
  export default class List extends mixins(deanTableMixin) {
    // DATA
    public pricePlans: any = [];
    public plusIcon: object = plusIcon;
    public duplicateIcon: object = duplicateIcon;
    public sideMenu: object = {
      title: {
        text: 'Prijsplannen',
        mobile: {
          close: {
            text: 'Close',
          },
        },
      },
      filters: {},
    };
    public columns: any = {
      name: {
        content: 'Naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      entriesCount: {
        content: 'Regels',
        align: 'left',
        sort: true,
        dql: 'entriesCount',
      },
    };

    // COMPUTED
    get metaData() {
      return this.pageMeta;
    }

    public tableName(): string {
      return 'settings-pricePlans';
    }

    // METHODS
    public cellClick(target: {
      cell: object, row: { id: string }, column: string,
    }) {
      this.$router.push({
        name: 'standingData.pricePlan.entries',
        params: {ppId: target.row.id},
      });
    }

    public loadList(data: any): void {
      this.$store.dispatch('setLoadOverlay', true);

      this.$store.dispatch('requestPricePlans', data)
        .then(
          (response) => {
            this.pricePlans = response.data.data.map((pricePlan: any) => {
              return {
                id: pricePlan.id,
                name: pricePlan.name ? pricePlan.name : '',
                entriesCount: pricePlan.entriesCount ? pricePlan.entriesCount : '0',
              };
            });

            this.updateMeta(response.data.meta);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => {
          this.$store.dispatch('setLoadOverlay', false);
        });
    }

    public created() {
      this.setDefaultSort('name');
      this.loadList(this.pageMeta);
      this.$store.dispatch('setStandingDataSideMenu', this.sideMenu);
    }
  }
</script>

<style lang="scss" scoped>

</style>
